import { afterNextRender } from "@polymer/polymer/lib/utils/render-status";

/**
 * Wait until the specified element is visible or the timeout period ellapses.
 * @param {HTMLElement} element
 * @param {Function} callback - Called with a single arg indicating if visible (true) or timed-out (false).
 * @param {int} [maxWaitPeriodMS=1000] - Milliseconds timeout, minimum = 10,000.
 */
export function whenVisible(element, callback, maxWaitPeriodMS) {
    if (typeof maxWaitPeriodMS !== 'number') maxWaitPeriodMS = 1000; // 1 second default
    else if (maxWaitPeriodMS > 10000) maxWaitPeriodMS = 10000; // max

    const startMS = Date.now();

    afterNextRender(element, () => {
        if (element.clientWidth && element.style.visibility !== 'hidden')
            callback(true);
        else {
            const ellapsedMS = Date.now() - startMS;
            const remainingMS = maxWaitPeriodMS - ellapsedMS;

            if (remainingMS <= 0)
                callback(false);
            else
                whenVisible(element, callback, remainingMS);
        }
    });
};